/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Breadcrumb } from "components/atoms/Breadcrumb";
import { TermSidebar } from "features/terms/TermSidebar";
import React from "react";
import { SubContentsLayout } from "ui/SubContentsLayout";

export const MusicCopyrightGuidelines: React.FC = () => {
  const classes = styles();

  return (
    <SubContentsLayout>
      <Breadcrumb
        // @ts-expect-error TS2322
        paths={[
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          ["/", "ホーム"],
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          [null, "音楽著作権ガイドライン"],
        ]}
      />

      <div css={classes.root}>
        {/* サイドバーを表示する */}
        <TermSidebar />

        {/* コンテンツを表示する */}
        <div css={classes.main}>
          <iframe
            // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
            title="音楽著作権ガイドライン"
            src="https://docs.google.com/document/d/e/2PACX-1vSmTXDuQ2p2m0sxgIRof4cfGd39Rs9zqerxeP-Hb6-Vwb9uG4362-p3ZbaQa8I3Fw/pub?embedded=true"
          ></iframe>
        </div>
      </div>
    </SubContentsLayout>
  );
};

const styles = () => {
  return {
    root: css`
      display: grid;
      grid-template-columns: 100%;
      grid-gap: 16px;
      width: 90%;
      max-width: 1140px;
      padding: 80px 0;
      margin: 0 auto;
      @media screen and (min-width: 768px) {
        grid-template-columns: 320px auto;
      }
    `,
    main: css`
      position: relative;
      width: 100%;
      iframe {
        width: 100%;
        height: 1000px;
      }
    `,
  };
};
